import { Card } from 'component/Card';
import { ReactComponent as FileDownloadIcon } from 'assets/images/icons/file_download.svg';
import { ReactComponent as FileIcon } from 'assets/images/icons/Files.svg';
import React from 'react';
import { Map } from 'component/Map';
import { TurnPointsFile } from './TurnPointsFile';
import { GisLinks, GisLinksView } from './Links';
import { useBufferZone } from 'hooks/useBufferZone';
import { useHAReports } from 'hooks/useHAReports';
import { HASwitchers } from 'component/HASwitchers';

export const GisBlock = ({
  turnPointsFiles,
  setTurnPointsFiles,
  map,
  setMap,
  turnPointsFromShape,
  setTurnPointsFromShape,
  gisLinks,
  setGisLinks,
  setTcpFormData,
  errors,
}) => {
  useBufferZone(map);
  const haReportsGisBlock = useHAReports(map);

  return (
    <div className="flex-column-group">
      <div className="download-cards flex-center">
        <Card
          header={
            <div className="flex-group flex-center">
              <div className="icon-wrapper">
                <FileDownloadIcon />
              </div>
              <span className={errors?.deminers_polygon ? 'error-text' : ''}>Turn points</span>
            </div>
          }
          body={
            <TurnPointsFile
              files={turnPointsFiles}
              setFiles={setTurnPointsFiles}
              setTurnPointsFromShape={setTurnPointsFromShape}
              links={gisLinks}
              setLinks={setGisLinks}
            />
          }
        />
      </div>
      <GisLinks links={gisLinks} setLinks={setGisLinks} setTcpFormData={setTcpFormData} />
      <div style={{ position: 'relative' }}>
        <HASwitchers
          {...haReportsGisBlock}
          googleWms={true}
          style={{
            position: 'absolute',
            top: '66px',
            zIndex: 1,
            background: 'rgba(255, 255, 255, 0.8)',
            borderRadius: '4px',
            padding: '0px 15px 7px 10px',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            left: '0px',
            borderRadius: '0 0 8px',
            boxShadow: '0px 20px 25px 0px rgba(76, 103, 100, 0.1)',
          }}
        />
        <Map
          map={map}
          setMap={setMap}
          turnPointsPolygon={turnPointsFromShape}
          haReportsPolygons={haReportsGisBlock?.haReportsPolygons}
          // azureLayerEnabled={haReportsGisBlock?.azureLayerEnabled}
          // setAzureLayerEnabled={haReportsGisBlock?.setAzureLayerEnabled}
          googleWms
        />
      </div>
    </div>
  );
};

export const GisBlockView = ({
  map,
  setMap,
  turnPointsFromShape,
  links,
  translatedFormData = {},
  translateState = false,
}) => {
  useBufferZone(map);
  const haReportsGisBlockView = useHAReports(map);

  return (
    <>
      <GisViewHeader />
      <GisLinksView
        links={links}
        translatedFormData={translatedFormData}
        translateState={translateState}
      />
      <div style={{ position: 'relative' }}>
        <HASwitchers
          {...haReportsGisBlockView}
          googleWms={true}
          style={{
            position: 'absolute',
            top: '66px',
            zIndex: 1,
            background: 'rgba(255, 255, 255, 0.8)',
            borderRadius: '4px',
            padding: '0px 15px 7px 10px',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            left: '0px',
            borderRadius: '0 0 8px',
            boxShadow: '0px 20px 25px 0px rgba(76, 103, 100, 0.1)',
          }}
        />
        <Map
          map={map}
          setMap={setMap}
          turnPointsPolygon={turnPointsFromShape}
          haReportsPolygons={haReportsGisBlockView?.haReportsPolygons}
          // azureLayerEnabled={haReportsGisBlockView?.azureLayerEnabled}
          // setAzureLayerEnabled={haReportsGisBlockView?.setAzureLayerEnabled}
          googleWms
        />
      </div>
    </>
  );
};

const GisViewHeader = () => (
  <div className="gis-header">
    <FileIcon />
    <span>File information</span>
    <div className="line" />
  </div>
);
